import { HubApiError } from "./hubApi.js";
// Prevent another redirect if Hub login did not establish a session.
const LOGIN_RETURN_PARAM = "hub_login";
export const takeLoginReturnMark = (url) => {
    if (!url.searchParams.has(LOGIN_RETURN_PARAM))
        return false;
    url.searchParams.delete(LOGIN_RETURN_PARAM);
    return true;
};
export const hubLoginRedirect = (error, hubOrigin, current, returnedFromLogin) => {
    if (!(error instanceof HubApiError && error.status === 401))
        return null;
    if (returnedFromLogin)
        return null;
    const returnTo = new URL(current);
    returnTo.searchParams.set(LOGIN_RETURN_PARAM, "1");
    const login = new URL("/login", hubOrigin);
    login.searchParams.set("return_to", returnTo.href);
    return login;
};
